import { Suspense, lazy } from "react";
import { useRoutes } from "react-router-dom";
// layouts
// import MainLayout from '../layouts/main';
import MasterLayout from "src/layouts/MasterLayout";
// import LogoOnlyLayout from '../layouts/LogoOnlyLayout';
// guards
import GuestGuard from "../guards/GuestGuard";
import AuthGuard from "../guards/AuthGuard";
// import RoleBasedGuard from "../guards/RoleBasedGuard";
// components
import LoadingScreen from "../components/LoadingScreen";
import Dashboard from "src/pages/dashboard/Dashboard";
import useStore from "src/contexts/AuthProvider";
import Register from "src/pages/authentication/Register";
import OtpVarification from "src/pages/authentication/OtpVerification";
import FoodItems from "src/pages/food/FoodItems";
import SubVendor from "src/pages/SubAdmin/SubVendor";
import GroceryItem from "src/pages/grocery/GroceryItem";
import FoodMenu from "src/pages/food/FoodMenu";
import GroceryMenu from "src/pages/grocery/GroceryMenu";
import EventMenu from "src/pages/events/Events";
import TravelMenu from "src/pages/travels/Travel";
import NgoMenu from "src/pages/ngo/Ngo";
import ForgotPassword from "src/pages/authentication/ForgotPassword";
import ResetPassword from "src/pages/authentication/ResetPassword";
import Order from "src/pages/order/order";
import OrderDetail from "src/pages/order/orderDetail";
import SupportTicket from "src/pages/support/SupportTicket";
import PendingOrder from "src/pages/order/PendingOrder";
import CompletedOrders from "src/pages/order/CompletedOrders";
import DisputedOrders from "src/pages/order/DisputedOrders";
import PendingPayout from "src/pages/payout/PendingPayout";
import CompletedPayout from "src/pages/payout/CompletedPayout";
import FeedBackRating from "src/pages/FeedBack/FeedbackRatings";
import ViewSupportRequest from "src/pages/support/ViewSupportRequest";
import EditSupportRequest from "src/pages/support/EditSupportRequest";
import BookedTicket from "src/pages/events/BookedTickets";
import PendingTicket from "src/pages/events/PendingTicket";
import TransactionList from "src/pages/payout/TransactionList";
import CharityTransaction from "src/pages/ngo/CharityTransaction";
import SubVendorProfile from "src/pages/dashboard/SubVendorProfile";
import KycUpload from "src/pages/KYC/kycUpload";
import BankDetail from "src/pages/KYC/BankDetails";
import ThankYou from "src/pages/authentication/ThankYou";
import CancelledOrders from "src/pages/order/CancelledOrders";
// import Advertistment from "src/pages/advertistment/Advertistment";
//enum
// import { AdminRole, UserRole } from "src/utils/enum";

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => {
  return (
    <Suspense
      fallback={
        <LoadingScreen
          sx={{
            ...{
              top: 0,
              left: 0,
              width: 1,
              zIndex: 9999,
              position: "fixed",
            },
          }}
        />
      }
    >
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  const userData = useStore((state) => state.user);
  const permissionData = useStore((state) => state.permissions);
  return useRoutes([
    //auth routes
    {
      path: "login",
      element: (
        <GuestGuard>
          <Login />
        </GuestGuard>
      ),
    },
    {
      path: "register",
      element: (
        <GuestGuard>
          <Register />
        </GuestGuard>
      ),
    },
    {
      path: "forgot-password",
      element: (
        <GuestGuard>
          <ForgotPassword />
        </GuestGuard>
      ),
    },
    {
      path: "otp-verification",
      element: (
        <GuestGuard>
          <OtpVarification />
        </GuestGuard>
      ),
    },
    {
      path: "reset-password",
      element: (
        <GuestGuard>
          <ResetPassword />
        </GuestGuard>
      ),
    },
    {
      path: "/thankyou",
      element: (
        <ThankYou />
      ),
    },
    {
      path: "kyc-upload",
      element: (
        <AuthGuard>
          <KycUpload userData={userData} />
        </AuthGuard>
      ),
    },
    {
      path: "dashboard",
      element: (
        <AuthGuard>
          {(userData?.request_status === 1 || userData?.request_status === 0) ? <KycUpload userData={userData} /> : <MasterLayout />}
          {/* <MasterLayout /> */}
        </AuthGuard>
      ),
      children: [
        (userData?.request_status === 1 || userData?.request_status === 0) ?
          {
            path: "/kyc-upload",
            element: <KycUpload userData={userData} />
          } :
          { path: "/", element: <Dashboard userData={userData} /> },
        {
          path: "auth-users",
          element: <Dashboard userData={userData} />
        },
        // {
        //   path: "items",
        //   element: userData?.category_type == 1 ? <FoodItems userData={userData} /> : <GroceryItem />
        // },
        {
          path: "/food-item",
          element: <FoodItems userData={userData} />
        },
        {
          path: "/grocery-item",
          element: <GroceryItem />
        },
        {
          path: "role-permission",
          element: <RolesPermissions userData={userData} />
        },
        // {
        //   path: "category",
        //   element: <Category />
        // },
        {
          path: "main-category",
          element: <MainCategory />
        },
        {
          path: "food-category",
          element: <FoodCategory />
        },
        {
          path: "grocery-category",
          element: <GroceryCategory />
        },
        {
          path: "food-menu",
          element: <FoodMenu />
        },
        {
          path: "grocery-menu",
          element: <GroceryMenu />
        },
        {
          path: "sub-vendor",
          element: <SubVendor />
        },
        // {
        //   path: "vendor",
        //   element: <Vendor />
        // },
        {
          path: "event-list",
          element: <EventMenu />
        },
        {
          path: "booked-tickets",
          element: <BookedTicket />
        },
        {
          path: "pending-tickets",
          element: <PendingTicket />
        },
        {
          path: "travel-menu",
          element: <TravelMenu />
        },
        {
          path: "ngo-menu",
          element: <NgoMenu />
        },
        {
          path: "advertisement",
          element: <Advertistment />
        },
        {
          path: "charity-transaction",
          element: <CharityTransaction />
        },
        {
          path: "order",
          element: <Order />
        },
        {
          path: "order-details",
          element: <OrderDetail />
        },
        {
          path: "pending-order",
          element: <PendingOrder />
        },
        {
          path: "completed-order",
          element: <CompletedOrders />
        },
        {
          path: "cancelled-order",
          element: <CancelledOrders />
        },
        {
          path: "disputed-order",
          element: <DisputedOrders />
        },
        {
          path: "my-payout",
          element: <PendingPayout userData={userData} />
        },
        {
          path: "completed-payout",
          element: <CompletedPayout />
        },
        {
          path: "transactions-list",
          element: <TransactionList />
        },
        {
          path: "support-ticket",
          element: <SupportTicket />
        },
        {
          path: "view-support-request",
          element: <ViewSupportRequest />
        },
        {
          path: "edit-support-request",
          element: <EditSupportRequest />
        },
        {
          path: "feedback-rating",
          element: <FeedBackRating /> 
        },
        {
          path: "bank-detail",
          element: <BankDetail />
        },
        {
          path: "getProfile",
          element: userData?.vendor_id ? <SubVendorProfile /> : <MyProfile />
        },
        { path: "changePassword", element: <ChangePassword userData={userData} /> },
        { path: "twoFactorAuthentication", element: <TwoFactorAuth /> }

      ],
    },
    {
      path: "/",
      element: (
        <AuthGuard>
          {(userData?.request_status === 1 || userData?.request_status === 0) ? <KycUpload userData={userData} /> : <MasterLayout />}
          {/* <MasterLayout /> */}
        </AuthGuard>
      ),
      children: [{ path: "/", element: <Dashboard /> }],
    },
  ]);
}

// IMPORT COMPONENTS

// Authentication
const Login = Loadable(lazy(() => import("../pages/authentication/Login")));

// Dashboard
// const ProfileSettings = Loadable(
//   lazy(() => import("../pages/dashboard/ProfileSettings"))
// );
// const Permission = Loadable(
//   lazy(() => import("../pages/dashboard/Permission"))
// );
const RolesPermissions = Loadable(
  lazy(() => import("../pages/dashboard/RolesPermissions"))
);
// const UsersList = Loadable(lazy(() => import("../pages/dashboard/UsersList")));
const MyProfile = Loadable(lazy(() => import("../pages/dashboard/MyProfile")));
// const Category = Loadable(lazy(() => import("../pages/dashboard/Category")))
const MainCategory = Loadable(lazy(() => import("../pages/dashboard/MainCategory")));
// const Vendor = Loadable(lazy(() => import("../pages/dashboard/Vendor")));
const ChangePassword = Loadable(lazy(() => import("../pages/dashboard/ChangePassword")));
const GroceryCategory = Loadable(lazy(() => import("../pages/grocery/GroceryCategory")))
const FoodCategory = Loadable(lazy(() => import("../pages/food/FoodCategory")))
const Advertistment = Loadable(lazy(() => import("../pages/advertistment/Advertistment")))
const TwoFactorAuth = Loadable(lazy(() => import("../pages/setting/TwoFactorAuth")));